export enum AccessPolicyStatus {
  PENDING = 'PENDING', // TO -> FROM : To need to accept the invitation
  INVITED = 'INVITED', // FROM -> TO : From need to accept the invitation
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}
